import React from 'react';
import {CropFree} from "@mui/icons-material";

function NullIcon(props) {
  return <CropFree {...props} style={{...props.style, fontSize:'16px'}} />;
  // return <SelectAll {...props} style={{clipPath:'polygon(0 0, 0 100%, 100% 100%, 100% 0, 0 0, 25% 25%, 75% 25%, 75% 75%, 25% 75%, 25% 25%)'}} />; /
}

export default NullIcon;
